export const styles = {
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #E65C00 0%, #F9D423 100%)',
	},
	submitContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: '1.4rem',
	},
	submitButton: {
		'&:disabled': {
			backgroundColor: 'primary.disabled',
			color: '#FFF',
		},
		'&:hover': {
			backgroundColor: 'primary.main',
			color: '#FFF',
		},
		backgroundColor: 'primary.main',
		borderRadius: 0,
		color: '#FFF',
		width: '15.5rem',
	},
	sectionText: {
		color: 'text.secondary',
		fontStyle: 'italic',
		maxHeight: '25rem',
	},
	cautionText: {
		opacity: 0.6,
	},
	header: {
		marginY: '2rem',
	},
	exampleIdeasBox: {
		padding: '1rem',
		backgroundColor: '#FFE9C9',
		color: 'black',
	},
	listItem: {
		margin: '10px 0',
	},
	proseMirror: {
		'.ProseMirror': {
			border: '1.5px solid #0000003B',
			borderBottomLeftRadius: '4px',
			borderBottomRightRadius: '4px',
		},
		'.ProseMirror-focused': {
			border: '2.5px solid #0000003B',
			borderBottomLeftRadius: '4px',
			borderBottomRightRadius: '4px',
		},
	},
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: '1',
		gap: '3.2rem',
	},
	threeColumnLayout: {
		display: 'flex',
		gap: '32px',
		flexDirection: {
			lg: 'row',
			md: 'row',
			sm: 'column',
			xs: 'column',
		},
	},
	columnBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		width: '100%',
	},
	gridItem: {
		minHeight: {
			xs: '15rem',
			sm: '20rem',
		},
	},
	richTextField: {
		background: '#FFE9C9',
		borderLeft: 'none',
		borderRight: 'none',
		borderTop: 'none',
	},
	unsureText: {
		fontSize: '1.8rem',
		color: '#000000DE',
	},
	dropdownContainer: {
		display: 'flex',
		gap: '32px',
		marginTop: '8px',
		flexDirection: {
			lg: 'row',
			md: 'row',
			sm: 'column',
			xs: 'column',
		},
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		gap: '1.6rem',
	},
}
